import { render, staticRenderFns } from "./PostingTypeCreate.vue?vue&type=template&id=586021e1"
import script from "./PostingTypeCreate.vue?vue&type=script&lang=js"
export * from "./PostingTypeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports